<template>
    <highcharts class="hole-chart" :options="chartOptions"></highcharts>
</template>

<script>
  export default {
    name: 'HoleChart',
    props: ['hole', 'title'],
    data() {
      return {
        labels: {
          "1" : "Ace", // GREEN 200
          "2" : "Birdie", // GREEN 500
          "3" : "Par", // BLUE 800
          "4" : "Bogey", // RED 200
          "5" : "Double", // RED 500
          "6" : "Tripple", // RED 800
        },
        chartColors: {
          "1": '#8db5f8',
          "2": '#9dd49d',
          "3": '#cccccc',
          "4": '#e89795',
          "5": '#df6e6b',
          "6": '#da5956'
        },
        chartOptions: {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false,
            margin:0,
            spacing:[0,0,0,0],
            height: 250,
          },
          title: {
            verticalAlign: 'middle',
            align: 'center',
            floating: true,
            text: null
          },
          credits: {
            enabled: false
          },
          tooltip: {
            pointFormat: '({point.y}) <b>{point.percentage:.1f}%</b>'
          },
          legend: {
            enabled: true,
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
            floating: false,
            backgroundColor: 'white',
            borderRadius: 3,
            labelFormat: '<b>{name}</b>: {percentage:.1f}% ({y})'
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: false,
                format: '<b>{point.name}</b>: {point.percentage:.1f}% ({point.y})',
                style: {
                  color: 'black'
                },
                distance: 10
              },
              // startAngle: -90,
              // endAngle: 90,
              center: ['30%', '50%'],
              allowPointSelect: false,
              showInLegend: true
            }
          },
          series: [{
            type: 'pie',
            name: 'Pars',
            innerSize: '60%',
            data: [],
          }]
        }
      };
    },
    methods: {
        updateChartData () {
          //this.chartOptions.title.text = this.title;

          const raw = Object.keys(this.hole.scores).map((key) => {
            return {
              name: this.labels[key],
              y: this.hole.scores[key],
              color: this.chartColors[key]
            }
          });

          this.chartOptions.series[0].data = raw;
        }
    },
    watch: {
      'hole': 'updateChartData'
    },
    mounted () {
      this.updateChartData();
    }
  }
</script>

<style scoped>

</style>
